export enum ACCOUNT_STATUS {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export enum BILLING_PLAN_TYPE {
  TERMED_INVOICE = 'termed_invoice',
  FREE = 'unlimited_free_trial',
  COMMUNITY_PLUS = 'community_plus',
  MARKETING_PARTNERSHIP = 'marketing_partnership',
  CREDIT_CARD = 'credit_card',
}

export const PASS_THROUGH_FEE_COMMUNICATION_CHANNEL = {
  SMS: 'sms',
  MMS: 'mms',
  WHATSAPP: 'whatsapp',
} as const

export type PassThroughFeeCommunicationChannel =
  typeof PASS_THROUGH_FEE_COMMUNICATION_CHANNEL[keyof typeof PASS_THROUGH_FEE_COMMUNICATION_CHANNEL]

export const PASS_THROUGH_FEE_TYPE = {
  PER_MESSAGE: 'per_message',
  PER_SEGMENT: 'per_segment',
} as const

export type PassThroughFeeType = typeof PASS_THROUGH_FEE_TYPE[keyof typeof PASS_THROUGH_FEE_TYPE]
